import {
  FORMEDIT_FORMATTR_MODAL_CHANGE,
} from './constants';

export function formAttrModalChange(visible,type) {
  return {
    type: FORMEDIT_FORMATTR_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FORMEDIT_FORMATTR_MODAL_CHANGE:
      return {
        ...state,
        formAttrModalType:action.data.type,
        formAttrModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/formedit/redux/formAttrModalChange.js